import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginUser } from "../store/authSlice";
import ApiLink from "../components/api/ApiLink";
import Swal from "sweetalert2";
import "animate.css";
import LoginPicture from "../assets/logo2.png";
import LogoPicture from "../assets/Group-2394-2.png";
import { useAuth } from "../components/context/authContext/AuthContext";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import CobrowseIO from "cobrowse-sdk-js";

// Custom styles for SweetAlert2
const swalStyles = `
  .swal-confirm-button,
  .swal-confirm-button[type="button"],
  .swal-confirm-button[type="submit"],
  .swal-confirm-button[type="reset"] {
    background-color: #62CB31 !important;
    background-image: none !important;
    color: white !important;
    border: none !important;
    padding: 12px 30px !important;
    border-radius: 5px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    box-shadow: 0 4px 15px rgba(98, 203, 49, 0.3) !important;
    transition: all 0.3s ease !important;
    -webkit-appearance: none !important;
    appearance: none !important;
    cursor: pointer !important;
    display: inline-block !important;
    line-height: 1.5 !important;
    text-align: center !important;
    text-decoration: none !important;
    vertical-align: middle !important;
    user-select: none !important;
    white-space: nowrap !important;
  }
  
  .swal-confirm-button:hover,
  .swal-confirm-button[type="button"]:hover,
  .swal-confirm-button[type="submit"]:hover,
  .swal-confirm-button[type="reset"]:hover {
    background-color: #74D348 !important;
    background-image: none !important;
    transform: translateY(-2px) !important;
    box-shadow: 0 6px 20px rgba(116, 211, 72, 0.4) !important;
  }
  
  .swal-confirm-button:active,
  .swal-confirm-button[type="button"]:active,
  .swal-confirm-button[type="submit"]:active,
  .swal-confirm-button[type="reset"]:active {
    transform: translateY(0) !important;
    background-image: none !important;
  }
  
  .swal-confirm-button:focus,
  .swal-confirm-button[type="button"]:focus,
  .swal-confirm-button[type="submit"]:focus,
  .swal-confirm-button[type="reset"]:focus {
    outline: none !important;
    box-shadow: 0 0 0 3px rgba(98, 203, 49, 0.3) !important;
  }
  
  .swal-custom-popup {
    border-radius: 15px !important;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;
  }
  
  /* Override any conflicting SweetAlert2 default styles */
  .swal2-popup .swal2-confirm {
    background-color: #62CB31 !important;
    background-image: none !important;
    color: white !important;
    border: none !important;
    padding: 12px 30px !important;
    border-radius: 5px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    box-shadow: 0 4px 15px rgba(98, 203, 49, 0.3) !important;
    transition: all 0.3s ease !important;
    -webkit-appearance: none !important;
    appearance: none !important;
  }
  
  .swal2-popup .swal2-confirm:hover {
    background-color: #74D348 !important;
    background-image: none !important;
    transform: translateY(-2px) !important;
    box-shadow: 0 6px 20px rgba(116, 211, 72, 0.4) !important;
  }
`;

// Inject styles into the document
if (typeof document !== "undefined") {
  const styleElement = document.createElement("style");
  styleElement.textContent = swalStyles;
  document.head.appendChild(styleElement);
}

CobrowseIO.license = "ZGm2HM8ayHQaOg";
CobrowseIO.start();

export default function Login() {
  const { loginUser } = useAuth();
  const [visiblePass, setVisiblePass] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);

  const [isRedirecting, setIsRedirecting] = useState(false);
  const { isAuthenticated, userType } = useAuth();

  React.useEffect(() => {
    if (isAuthenticated && userType === 1) {
      setIsRedirecting(true);
      window.location.href = "/accounts";
    }
  }, [isAuthenticated, userType]);

  if (isRedirecting) {
    return (
      <div className="flex justify-center items-center h-screen">
        Redirecting...
      </div>
    );
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    const password = e.target.password.value;

    setShowSpinner(true); // Show spinner

    try {
      // Simulate login delay (replace with actual login logic)
      const loginSuccessful = await loginUser(email, password);

      if (loginSuccessful) {
        // Handle successful login
        console.log("Login successful");
      }
    } catch (error) {
      console.error("Login error:", error);
      // Handle login error
    } finally {
      setShowSpinner(false); // Hide spinner
    }
  };

  const toggleVisiblePass = () => {
    setVisiblePass(!visiblePass);
  };

  const handleClickGenerateCode = () => {
    // Call the global showSessionCode function
    try {
      CobrowseIO.client().then(function () {
        // create a code a display it to the user using your own UI
        // ONLY GENERATE CODE WHEN NEEDED. DO NOT GENERATE CODE ON PAGE LOAD.
        CobrowseIO.createSessionCode().then(function (code) {
          console.log("your code is", code);
          Swal.fire({
            title: "Your Remote Session Code",
            text: `Code: ${code}`,
            icon: "success",
            confirmButtonText: "OK",
            confirmButtonColor: "#62CB31",
            customClass: {
              confirmButton: "swal-confirm-button",
              popup: "swal-custom-popup",
            },
            buttonsStyling: true,
            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          });
        });
      });
    } catch (error) {
      console.error("Error creating session:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to generate session code",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className="min-h-screen shadow-xl flex items-center justify-center px-4 py-10 sm:px-6 lg:px-8 bg-gray-100">
      <div className="max-w-7xl w-full bg-white shadow-xl rounded-lg flex flex-col md:flex-row">
        {/* Left: Image */}
        <div className="hidden md:flex md:w-full bg-gray-300 rounded-l-lg overflow-hidden">
          <img
            src="https://app.sustainablesprinkler.com/images/devices_login.png"
            alt="Smart irrigation devices"
            className="object-contain w-full h-full"
          />
        </div>
        {/* Right: Login Form */}
        <div className="flex flex-col shadow-xl justify-center items-center md:w-1/2 p-8 sm:p-12">
          <div className="w-full">
            <div className="flex justify-center mb-4">
              <img src={LogoPicture} alt="Logo" className="h-28" />
            </div>
            {showSpinner && (
              <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-md">
                <div className="flex items-center justify-center">
                  <svg
                    className="animate-spin h-5 w-5 text-blue-600 mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  <span className="text-blue-800 text-sm font-medium">
                    Logging you in...
                  </span>
                </div>
              </div>
            )}
            <h2 className="text-center text-xl font-extrabold text-gray-900 mb-2">
              Welcome to{" "}
              <span style={{ color: "#009d01" }}>Sustainable Sprinkler</span>
            </h2>
            <p className="text-center text-sm text-gray-600 mb-6">
              Fill the credentials below to log into Sustainable Sprinkler
            </p>
            <form className="space-y-6" onSubmit={handleSubmit}>
              {/* Email Address Input */}

              <div className="flex mb-6">
                <span className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="w-6 h-6 text-gray-500"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
                    />
                  </svg>
                </span>
                <input
                  type="text"
                  id="email"
                  placeholder="Email Address"
                  disabled={showSpinner}
                  className="rounded-none rounded-e-lg bg-gray-200 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5 disabled:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-75"
                  autoComplete="email"
                />
              </div>

              {/* Password Input */}
              <div className="flex mb-6 items-center">
                <span className="inline-flex items-center px-3 py-2 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="w-6 h-6 text-gray-500"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                    />
                  </svg>
                </span>

                <div className="relative flex-1">
                  <input
                    type={visiblePass ? "text" : "password"}
                    id="password"
                    placeholder="Password"
                    disabled={showSpinner}
                    className="rounded-none rounded-e-lg bg-gray-200 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block w-full text-sm border-gray-300 p-2.5 disabled:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-75"
                    autoComplete="current-password"
                  />
                  <div
                    className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
                    onClick={toggleVisiblePass}
                  >
                    {visiblePass ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-6 h-6 "
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="size-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                        />
                      </svg>
                    )}
                  </div>
                </div>
              </div>

              {/* Remember Me Checkbox */}
              <div className="flex items-center justify-between text-sm">
                <div
                  className={`ml-2 block text-md text-gray-900 cursor-pointer ${
                    showSpinner
                      ? "opacity-50 cursor-not-allowed"
                      : "hover:text-gray-700"
                  }`}
                  htmlFor="generateCode"
                  onClick={showSpinner ? undefined : handleClickGenerateCode}
                >
                  Generate Code
                </div>
                <div className="flex items-center">
                  <Link
                    to="/forgot-password"
                    className={showSpinner ? "pointer-events-none" : ""}
                  >
                    <label
                      className={`font-medium text-md cursor-pointer text-red-500 ${
                        showSpinner ? "opacity-50" : "hover:text-red-600"
                      }`}
                    >
                      Forgot Password
                    </label>
                  </Link>
                </div>
              </div>
              {/* Forgot Password Link */}

              {/* Login Button */}
              <button
                type="submit"
                disabled={showSpinner}
                className="w-full flex shadow-lg justify-center py-2 px-4 border border-transparent rounded-md text-sm font-medium text-white bg-[#62CB31] hover:bg-[#74D348] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#62CB31] disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#62CB31] transition-all duration-200"
              >
                {showSpinner ? (
                  <>
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Logging In...
                  </>
                ) : (
                  "Login"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
